import cars_brand from '../views/cars_brand/index.vue'
import cars_brand_create from '../views/cars_brand/create.vue'
import cars_brand_detail from '../views/cars_brand/detail.vue'
import cars_brand_edit from '../views/cars_brand/edit.vue'
import cars_brand_import from '../views/cars_brand/import.vue'

const routes = [
  {
    path: "/cars_brand",
    name: "cars_brand",
    component: cars_brand,
    meta: { authOnly: true },
  },
  {
    path: "/cars_brand/create",
    name: "cars_brand_create",
    component: cars_brand_create,
    meta: { authOnly: true },
  },
  {
    path: "/cars_brand/edit/:uuid",
    name: "cars_brand_edit",
    component: cars_brand_edit,
    meta: { authOnly: true },
  },
  {
    path: "/cars_brand/detail/:uuid",
    name: "cars_brand_detail",
    component: cars_brand_detail,
    meta: { authOnly: true },
  },
  {
    path: "/cars_brand/import",
    name: "cars_brand_import",
    component: cars_brand_import,
    meta: { authOnly: true },
  },
]

export default routes
